export namespace ErrorMessages {
    export enum CRUD_403_ERRORS {
      // Error message when trying to create a resource but access is forbidden
      CREATE = 'You do not have the necessary permissions to create this resource. Please contact your administrator for access.',
      
      // Error message when trying to read a resource but access is forbidden
      READ = 'You are not authorized to access this resource. Please ensure you have the required permissions.',
      
      // Error message when trying to update a resource but access is forbidden
      UPDATE = 'You do not have permission to update this resource. Please check with your administrator for appropriate access rights.',
      
      // Error message when trying to delete a resource but access is forbidden
      DELETE = 'You are not allowed to delete this resource. Please verify your permissions with your administrator.',
    }
  }